import {
  AddItemToBasketRequest,
  addItemToBasketRequestOutputTransformer,
} from '../Basket/AddItemToBasketRequest';
import {
  GuestAddress,
  guestAddressOutputTransformer,
} from '../Address/GuestAddress';
import {
  CreditCardForm,
  creditCardFormOutputTransformer,
  getEmptyCreditCardForm,
} from './CreditCardForm';
import { PaymentMethod } from './PaymentMethod';

export interface PaymentForm {
  email: string;
  phone: string;
  firstName: string;
  lastName: string;
  dynamicBasket: AddItemToBasketRequest[];
  guestAddress?: GuestAddress;
  addressID?: number;
  notes: string;
  paymentMethod: PaymentMethod;
  shippingMethod: number;
  freeShipping: boolean;
  couponID?: number;
  couponAmount?: number;
  billingAddressID?: number;
  taxNumber?: string;
  taxOffice?: string;
  point?: number;
  creditCardForm: CreditCardForm;
}

export const paymentFormOutputTransformer = (paymentForm: PaymentForm) => ({
  customer_email: paymentForm.email,
  customer_phone: paymentForm.phone,
  customer_first_name: paymentForm.firstName,
  customer_last_name: paymentForm.lastName,
  dynamic_basket: paymentForm.dynamicBasket.length
    ? paymentForm.dynamicBasket.map(addItemToBasketRequestOutputTransformer)
    : undefined,
  guest_address: paymentForm.guestAddress
    ? guestAddressOutputTransformer(paymentForm.guestAddress)
    : undefined,
  address: paymentForm.addressID,
  notes: paymentForm.notes,
  payment_method: paymentForm.paymentMethod,
  shipping_method: { id: paymentForm.shippingMethod },
  free_shipping: paymentForm.freeShipping,
  coupon_id: paymentForm.couponID,
  coupon: paymentForm.couponAmount
    ? { value: { amount: paymentForm.couponAmount } }
    : undefined,
  billing_address: paymentForm.billingAddressID,
  vergi_no: paymentForm.taxNumber,
  vergi_dairesi: paymentForm.taxOffice,
  point: paymentForm.point,
  checkoutForm: creditCardFormOutputTransformer(paymentForm.creditCardForm),
});

export const getEmptyPaymentForm = (): PaymentForm => ({
  email: '',
  phone: '',
  firstName: '',
  lastName: '',
  dynamicBasket: [],
  notes: '',
  paymentMethod: 'credit_card',
  shippingMethod: 1,
  freeShipping: false,
  creditCardForm: getEmptyCreditCardForm(),
});
